module.exports = __webpack_public_path__ + "images/backgrounds/icon-pattern_09f0a12d615920426d8486c4d88031d8.jpg";